import { type LoggerTransformation } from '@service-initiation/shared-clients-logger';

export const withTimezoneContext: LoggerTransformation = (report) => {
  return {
    ...report,
    context: {
      ...report.context,
      timezone: -new Date().getTimezoneOffset() / 60 + 0, // +0 -> in order to avoid -0
    },
  };
};
